import { Flow_0_0_2 } from '@flexus/core';

export const BUI_80: Flow_0_0_2 = {
	id: '80',
	name: 'no_work_customer_cancelled',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'No work, customer cancelled'
		}
	},
	startNode: '',
	nodes: {}
};
